import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'app-fullscreen-loading',
    templateUrl: './fullscreen-loading.component.html',
    styleUrls: ['./fullscreen-loading.component.scss'],
    standalone: false
})
export class FullscreenLoadingComponent implements OnInit, OnDestroy {
    public isLoading: boolean = false;
    public message: string = '';
    private destroy$ = new Subject<void>();

    constructor(private loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.loading$
            .pipe(takeUntil(this.destroy$))
            .subscribe(loading => {
                this.isLoading = loading;
            });

        this.loadingService.loadingMessage$
            .pipe(takeUntil(this.destroy$))
            .subscribe(message => {
                this.message = message;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
